import { ApprovalStatus } from "../../../../../../components";
import { useColumn } from "../../../Employees/hooks/use-column";
import { Form } from "antd";
import { DateFormat } from "../../../../../../constants";
import Input from "rc-input";
import { DateHelper } from "../../../../../../helper";

export const useRepairToolColumn = () => {
  const { getColumnSearchProps, isEditing } = useColumn();

  const repairToolColumn = [
    {
      title: "Số phiếu",
      dataIndex: "id",
      editable: false,
      align: "center" as const,
      ...getColumnSearchProps("id", "Vui lòng nhập số phiếu"),
    },
    {
      title: "Người tạo",
      dataIndex: "createdName",
      editable: false,
      width: 200,
      ...getColumnSearchProps("createdName", "Vui lòng nhập người tạo"),
    },
    {
      title: "Tiêu đề",
      dataIndex: "Title",
      editable: false,
      width: 200,
    },
    {
      title: "Tình trạng",
      dataIndex: "eRequestStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Cán bộ CNTT",
      dataIndex: "eApprovedBy",
      editable: false,
      render: (_: any, record: any) =>
        !record.eApprovedStatus && isEditing(record) ? (
          <Form.Item
            name={"eApprovedBy"}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Vui lòng nhập Cán bộ CNTT!`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          record.eApprovedBy
        ),
    },
    {
      title: "Trạng thái Cán bộ CNTT",
      dataIndex: "eApprovedStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Ngày Cán bộ CNTT phê duyệt",
      dataIndex: "eApprovedDate",
      editable: false,
      render: (text: string) => DateHelper.formatDateToString(text, { format: DateFormat.DD_MM_YYYY_HH_MM }),
    },
    {
      title: "CNTT thực hiện",
      dataIndex: "eApprovedByITHead",
      render: (_: any, record: any) =>
        !record.eApprovedByITHeadStatus && isEditing(record) ? (
          <Form.Item
            name={"eApprovedByITHead"}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Vui lòng nhập CNTT thực hiện!`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          record.eApprovedByITHead
        ),
    },
    {
      title: "Trạng thái CNTT thực hiện",
      dataIndex: "eApprovedByITHeadStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Ngày CNTT thực hiện phê duyệt",
      dataIndex: "eApprovedByITHeadDate",
      editable: false,
      render: (text: string) => DateHelper.formatDateToString(text, { format: DateFormat.DD_MM_YYYY_HH_MM }),
    },
    {
      title: "CQ/ĐV nghiệm thu",
      dataIndex: "eAssignee",
      editable: false,
      render: (_: any, record: any) =>
        !record.eAssigneeStatus && isEditing(record) ? (
          <Form.Item
            name={"eAssignee"}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Vui lòng nhập cán bộ hoàn tất/nghiệm thu!`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          record.eAssignee
        ),
    },
    {
      title: "Trạng thái CQ/ĐV nghiệm thu",
      dataIndex: "eAssigneeStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Ngày CQ/ĐV nghiệm thu",
      dataIndex: "eAssigneeStatusDate",
      editable: false,
      render: (text: string) => DateHelper.formatDateToString(text, { format: DateFormat.DD_MM_YYYY_HH_MM }),
    },
  ];
  return { repairToolColumn };
};
